import styled from "styled-components";

export default styled.div`
    height: 80vh;
    max-height: 100vh;
    margin-top: 20px;
`;
